import HeaderLogo from '@/assets/svg/HeaderLogo';

import {
  Sheet,
  SheetContent,
  SheetClose,
  SheetTrigger,
} from '@/components/ui/sheet';

import Tags from './components/Tags';
import { IComponentProps } from '@/interfaces/component.interface';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import LangSelect from '@/components/layout/LangSelect';
import { Locale } from '@/enums/locale.enum';

interface ComponentProps extends IComponentProps {
  text: any;
  tags: any;
  lang: Locale;
}

const MenuLinks = [
  {
    name: 'Studio',
    href: '/studio',
  },
  {
    name: 'Services',
    href: '/services',
  },
  {
    name: 'Projects',
    href: '/portfolio',
  },
  {
    name: 'Blog',
    href: '/blog',
  },
  {
    name: 'Products',
    href: '/products',
  },
];

export default function Index(props: ComponentProps) {
  const { text, lang, tags } = props;

  return (
    <Sheet>
      <SheetTrigger>Menu</SheetTrigger>
      <SheetContent
        close={lang === 'en' ? 'Close' : 'Chiudi'}
        style={{
          zIndex: 1000,
        }}
        className='pr-4 text-[#101011]'
      >
        <div className='flex flex-col gap-20 h-full pb-4'>
          <div className='w-36 h-6'>
            <HeaderLogo />
          </div>

          <div className='flex flex-col justify-between h-full'>
            <div className='text-6xl sm:text-4xl space-y-3'>
              <div className='flex items-end justify-between'>
                <SheetClose>
                  <Link href='/contact'>
                    <Button
                      variant='link'
                      className='px-5 py-0.5 h-max text-[13px] leading-none align-middle border border-[#101011] rounded-2xl'
                    >
                      <span>{lang === 'en' ? 'CONTACT' : 'CONTATTI'}</span>
                    </Button>
                  </Link>
                </SheetClose>
                <LangSelect
                  className='text-[#101011] mb-1 text-[13px] leading-[120%] '
                  lang={lang}
                />
              </div>
              {MenuLinks.map((item, index) => (
                <div key={index}>
                  <Link href={item.href}>
                    <SheetClose className='text-left text-[40px] leading-6 tracking-normal uppercase mb-[21px]'>
                      {text[item.name.toLowerCase()]}
                    </SheetClose>
                  </Link>
                </div>
              ))}
            </div>
            <div className='flex flex-col gap-4'>
              <p className='text-[11px] leading-none tracking-normal font-bold'>
                {lang === 'en' ? 'OUR PROJECTS' : 'I NOSTRI PROGETTI'}
              </p>
              <Tags lang={lang} text={tags} />
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
